//Отображать ли новый вид и функционал подписки?
import store from '@shared/store/index.js';
import { computed } from 'vue';

/* export const SHOWED_NEW_SUBSCRIPTION = computed(() => store.getters['UserSystem/hasModeratorPrivileges']); */
export const SHOWED_NEW_SUBSCRIPTION = true;
//----------------------------------------------

//Доступна ли легендарная подписка (оформление и продление)? Временно скрыта.
export const LEGEND_SUBSCRIPTION_ENABLED = false;
//----------------------------------------------

//Время (в мс), через которое будет отправляться запрос, на обновления данных
export const DATA_UPDATE_INTERVAL_SIZE = 1000 * 60;